import React, { useEffect, useRef } from 'react';

type VideoProps = {
    alt?: string;
    url: string;
};

export const Video: React.FC<VideoProps> = ({ alt, url }) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const videoElement = videoRef.current;
        return () => {
            if (videoElement) {
                videoElement.pause();
                videoElement.volume = 0;
            }
        };
    }, [videoRef]);

    return (
        <video
            ref={videoRef}
            className="NativeVideo__video"
            title={alt || 'Native video content'}
            src={url}
            controls
            autoPlay
            loop
            playsInline
            onClick={(e) => e.stopPropagation()}
            controlsList="nodownload nofullscreen"
        />
    );
};
